export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  excerpt: string;
  content: string;
  image: string;
  date: string;
  author: string;
  tags: string[];
  readTime: string;
  featured: boolean;
}

export const articles: Article[] = [
  // ===== 免费影视 =====
  {
    id: 'art-001',
    title: '2025年最佳免费在线影视平台推荐：高清观影零成本',
    slug: 'best-free-movie-platforms-2025',
    category: 'free-movies',
    excerpt: '盘点2025年最值得收藏的免费在线影视平台，涵盖国内外热门电影、电视剧资源，无需注册即可在线观看，高清画质流畅不卡顿。',
    content: `<p>在如今的互联网时代，观看影视作品已经不再局限于传统的电视和电影院。随着在线影视平台的蓬勃发展，越来越多的用户选择通过网络观看电影和电视剧。然而，面对琳琅满目的付费平台，许多用户仍然在寻找高质量的<strong>免费在线影视平台</strong>。</p>

<h2>一、国内优质免费影视平台</h2>

<p>国内主流的视频平台虽然大多采用会员制，但仍有不少平台提供丰富的免费内容。以下是几个值得推荐的免费影视资源入口：</p>

<h3>1. 1905电影网</h3>
<p>作为央视电影频道旗下的官方平台，1905电影网拥有海量正版电影资源。平台每天更新大量经典老片和部分新片，画质清晰，支持高清播放。用户无需注册即可直接访问观看，是非常良心的<strong>免费影视平台</strong>。</p>

<h3>2. B站影视区</h3>
<p>哔哩哔哩弹幕网（B站）的影视区汇集了大量用户上传和官方引进的影视内容。从经典港片到热门日剧，从纪录片到独立电影，内容覆盖面极广。弹幕互动功能更是为观影增添了独特的社交体验。</p>

<h2>二、国际知名免费影视资源</h2>

<p>对于喜欢观看海外影视内容的用户，以下国际平台同样提供优质的免费观影服务：</p>

<h3>1. Tubi TV</h3>
<p>Tubi 是福克斯公司旗下的免费流媒体平台，拥有超过20000部电影和电视剧集。平台通过广告模式运营，用户无需支付任何费用即可观看全部内容。支持中文字幕的影片数量也在不断增加。</p>

<h3>2. Pluto TV</h3>
<p>Pluto TV 提供了独特的"电视直播+点播"混合模式。用户可以像看电视一样切换频道，也可以随时点播想看的节目。平台上汇聚了各类经典影视内容，是<strong>免费在线影视</strong>爱好者的理想选择。</p>

<h2>三、免费观影小贴士</h2>
<p>在使用免费影视平台时，建议用户注意以下几点：选择正规合法的平台，避免使用盗版网站；注意个人隐私保护，不随意在不明网站注册账号；合理安排观影时间，保护视力健康。通过<strong>免费91 网页</strong>的影视资源导航，您可以安全便捷地找到最适合自己的观影平台。</p>`,
    image: 'https://readdy.ai/api/search-image?query=modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20movie%20content%2C%20warm%20ambient%20lighting%2C%20cozy%20living%20room%20atmosphere%2C%20cinematic%20experience%2C%20minimalist%20interior%20design%2C%20soft%20golden%20light%2C%20high%20quality%20photography%2C%20clean%20composition&width=800&height=450&seq=article-free-movies-001&orientation=landscape',
    date: '2025-08-08',
    author: '91小编',
    tags: ['免费影视', '在线观影', '影视平台', '高清电影'],
    readTime: '8分钟',
    featured: true,
  },
  {
    id: 'art-002',
    title: '免费动漫追番指南：这些网站让你看番不花钱',
    slug: 'free-anime-streaming-guide',
    category: 'free-movies',
    excerpt: '为动漫爱好者整理的免费追番攻略，从经典老番到当季新番，这些平台让你零成本畅享二次元世界的精彩。',
    content: `<p>动漫作为一种独特的艺术形式，在全球范围内拥有大量忠实粉丝。对于国内的动漫爱好者来说，如何在不花费高额会员费的情况下追到自己喜欢的番剧，是一个值得探讨的话题。本文将为大家详细介绍几个<strong>免费动漫追番</strong>的好去处。</p>

<h2>一、国内免费动漫平台推荐</h2>
<p>国内的动漫平台经过多年发展，已经形成了较为完善的生态体系。以下平台提供了丰富的免费动漫内容：</p>

<h3>1. 哔哩哔哩动画区</h3>
<p>作为国内最大的二次元社区，B站的动画区拥有海量的正版动漫资源。从《鬼灭之刃》《进击的巨人》到《咒术回战》，热门番剧应有尽有。虽然部分新番需要大会员，但大量经典番剧和国产动画都可以免费观看。</p>

<h3>2. AGE动漫</h3>
<p>AGE动漫是一个专注于动漫资源的聚合平台，提供了丰富的动漫资源链接。网站界面简洁，分类清晰，支持按年份、类型、地区等多种方式筛选。用户可以快速找到自己想看的动漫，是<strong>免费动漫资源</strong>的重要入口。</p>

<h2>二、国际动漫流媒体平台</h2>
<p>除了国内平台，一些国际动漫平台也提供了免费内容：</p>

<h3>Crunchyroll 免费版</h3>
<p>Crunchyroll 是全球最大的动漫流媒体平台之一，虽然大部分内容需要订阅，但其免费版仍然提供了相当数量的可观看动漫。每周更新的新番通常会在付费用户观看一周后向免费用户开放。</p>

<h2>三、追番工具与技巧</h2>
<p>善用追番工具可以让你的动漫观看体验更加顺畅。推荐使用追番日历类应用来追踪每周更新的番剧，避免错过任何一集。同时，<strong>免费91 网页</strong>也会持续更新动漫资源的导航信息，帮助动漫爱好者找到更多优质的免费观影渠道。</p>`,
    image: 'https://readdy.ai/api/search-image?query=colorful%20anime%20style%20illustration%20with%20vibrant%20characters%2C%20Japanese%20animation%20aesthetic%2C%20dynamic%20composition%2C%20warm%20lighting%2C%20artistic%20background%20with%20soft%20gradients%2C%20clean%20and%20modern%20design&width=800&height=450&seq=article-free-movies-002&orientation=landscape',
    date: '2025-08-06',
    author: '91小编',
    tags: ['免费动漫', '追番指南', '二次元', '动画资源'],
    readTime: '7分钟',
    featured: false,
  },
  // ===== 免费音乐 =====
  {
    id: 'art-003',
    title: '免费在线音乐平台精选：高品质音乐随心听',
    slug: 'best-free-music-platforms',
    category: 'free-music',
    excerpt: '整理当前最受欢迎的免费音乐播放平台，从流行金曲到独立音乐，这些平台让你无需付费也能享受高品质音乐体验。',
    content: `<p>音乐是生活中不可或缺的调味剂。无论是在通勤路上、工作时还是休闲放松，一首好歌总能带来愉悦的心情。然而，随着音乐版权意识增强，越来越多的音乐平台开始收费。本文将为您推荐几个依然可以<strong>免费在线听歌</strong>的优质平台。</p>

<h2>一、国内主流免费音乐平台</h2>

<h3>1. 网易云音乐</h3>
<p>网易云音乐虽然推出了黑胶VIP会员服务，但其免费版仍然提供了大量可播放的歌曲。平台以精准的个性化推荐和活跃的社区氛围著称，用户可以创建歌单、发表评论、分享音乐心情。每日推荐和私人FM功能让发现好音乐变得更加简单。</p>

<h3>2. QQ音乐</h3>
<p>作为腾讯旗下的音乐平台，QQ音乐拥有最全面的华语音乐版权库。免费用户可以收听大部分歌曲（可能伴有广告），同时享受基础的音乐推荐服务。平台的音质选择丰富，支持标准音质到无损音质多种选项。</p>

<h2>二、国际免费音乐平台</h2>

<h3>1. Spotify Free</h3>
<p>Spotify 是全球最受欢迎的音乐流媒体服务，其免费版虽然会有广告插播且部分功能受限，但仍然是一个极佳的<strong>免费音乐</strong>来源。平台拥有超过7000万首歌曲的庞大曲库，涵盖各种语言和风格。算法推荐极其精准，能够根据你的听歌习惯不断优化推荐内容。</p>

<h3>2. SoundCloud</h3>
<p>SoundCloud 是一个独特的音乐平台，汇聚了大量独立音乐人和创作者的作品。平台上有许多在其他地方找不到的原创音乐、混音和翻唱作品。对于喜欢探索新鲜音乐的听众来说，SoundCloud 是一个不可多得的<strong>免费音乐资源</strong>宝库。</p>

<h2>三、在线音乐电台</h2>
<p>除了点播式的音乐平台，在线音乐电台也是一个很好的免费听歌选择。豆瓣FM、Last.fm 等平台通过电台模式为用户推送音乐，无需手动选歌，特别适合作为背景音乐使用。通过这些<strong>免费在线音乐</strong>渠道，您可以轻松构建属于自己的音乐世界。</p>`,
    image: 'https://readdy.ai/api/search-image?query=elegant%20music%20listening%20space%20with%20headphones%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20minimalist%20interior%2C%20cozy%20atmosphere%2C%20soft%20golden%20light%2C%20high%20quality%20product%20photography%2C%20clean%20composition&width=800&height=450&seq=article-free-music-001&orientation=landscape',
    date: '2025-08-05',
    author: '91小编',
    tags: ['免费音乐', '在线听歌', '音乐平台', '流媒体'],
    readTime: '8分钟',
    featured: true,
  },
  {
    id: 'art-004',
    title: '免费音乐制作工具合集：零成本开启你的音乐创作之旅',
    slug: 'free-music-production-tools',
    category: 'free-music',
    excerpt: '为音乐爱好者整理的全套免费音乐制作工具，从编曲软件到音效素材库，让你不花一分钱就能开始音乐创作。',
    content: `<p>音乐创作不再是专业音乐人的专利。随着数字化工具的发展，任何对音乐有热情的人都可以尝试创作属于自己的音乐。更重要的是，现在有许多优秀的<strong>免费音乐制作工具</strong>可供使用。本文将为您详细介绍这些零成本的创作利器。</p>

<h2>一、免费数字音频工作站（DAW）</h2>

<h3>1. Cakewalk by BandLab</h3>
<p>Cakewalk 曾经是一款昂贵的专业音频工作站，如今被 BandLab 收购后完全免费开放。它提供了完整的录音、编辑、混音功能，支持VST插件，界面专业且功能强大。无论是录制人声还是制作电子音乐，Cakewalk 都能胜任。</p>

<h3>2. LMMS</h3>
<p>LMMS（Linux MultiMedia Studio）是一款开源的数字音频工作站，跨平台支持 Windows、macOS 和 Linux。内置了大量的虚拟乐器和效果器，特别适合电子音乐制作。作为<strong>免费编曲软件</strong>的佼佼者，LMMS 的社区活跃且教程丰富。</p>

<h2>二、免费音效与采样资源</h2>

<h3>1. Freesound</h3>
<p>Freesound 是一个庞大的免费音效数据库，拥有超过50万个用户上传的音效样本。从自然环境音到合成音效，从乐器采样到人声素材，种类繁多。所有音效均可免费下载使用，是音频创作者的必备资源库。</p>

<h3>2. BBC Sound Effects</h3>
<p>BBC 将其庞大的音效档案库向公众免费开放，包含超过16000个高质量音效文件。这些音效来自BBC数十年的广播制作积累，质量极高，涵盖了自然、城市、交通、动物等各个类别。</p>

<p>通过这些<strong>免费音乐制作资源</strong>，任何人都可以零成本开启音乐创作之旅。<strong>免费91 网页</strong>将持续关注和更新音乐创作相关的免费资源，为音乐爱好者提供最全面的导航服务。</p>`,
    image: 'https://readdy.ai/api/search-image?query=modern%20music%20production%20studio%20with%20MIDI%20keyboard%20and%20computer%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%2C%20minimalist%20design%2C%20cozy%20atmosphere%2C%20soft%20golden%20tones%2C%20professional%20photography&width=800&height=450&seq=article-free-music-002&orientation=landscape',
    date: '2025-08-03',
    author: '91小编',
    tags: ['音乐制作', '免费工具', '编曲软件', '音效素材'],
    readTime: '9分钟',
    featured: false,
  },
  // ===== 免费工具 =====
  {
    id: 'art-005',
    title: '2025年必备免费在线工具推荐：效率提升300%的秘密武器',
    slug: 'essential-free-online-tools-2025',
    category: 'free-tools',
    excerpt: '精选30+款实用免费在线工具，涵盖图片处理、文档转换、视频编辑、开发辅助等类别，让你工作效率翻倍。',
    content: `<p>在日常工作和学习中，我们经常需要处理各种格式的文件、编辑图片、转换文档等。安装专业软件不仅占用空间，还需要花费大量时间学习。而<strong>免费在线工具</strong>的出现完美解决了这些痛点，无需下载安装，打开浏览器即可使用。本文为您精选了2025年最实用的免费在线工具合集。</p>

<h2>一、图片处理工具</h2>

<h3>1. Canva 免费版</h3>
<p>Canva 是目前最受欢迎的在线设计工具之一，其免费版已经提供了海量的模板和设计元素。无论是制作社交媒体图片、海报、名片还是PPT，Canva 都能轻松应对。拖拽式操作，零设计基础也能做出专业级作品。</p>

<h3>2. Remove.bg</h3>
<p>一键去除图片背景的神器。只需上传图片，AI 算法会自动识别主体并去除背景，效果惊艳。对于需要制作透明背景图片的用户来说，这款<strong>免费图片处理工具</strong>简直是必备利器。</p>

<h2>二、文档处理工具</h2>

<h3>1. Smallpdf</h3>
<p>Smallpdf 提供了全面的PDF处理功能：合并、拆分、压缩、转换格式等。每天有免费使用额度，基本满足日常需求。支持 PDF 与 Word、Excel、PPT、JPG 等格式的互转，是办公场景中的得力助手。</p>

<h3>2. Google Docs</h3>
<p>谷歌文档是完全免费的在线办公套件，包括文档、表格和幻灯片。支持多人实时协作编辑，自动保存到云端，随时随地访问。与 Microsoft Office 格式兼容良好，是最受欢迎的<strong>免费办公工具</strong>之一。</p>

<h2>三、开发与设计工具</h2>

<h3>1. CodePen</h3>
<p>前端开发者的在线游乐场。在浏览器中实时编写 HTML、CSS 和 JavaScript 代码并预览效果。社区中分享的大量创意作品也是学习和获取灵感的好地方。</p>

<h3>2. Figma 免费版</h3>
<p>Figma 是当前最热门的在线UI设计工具，免费版对个人用户非常友好。支持矢量编辑、原型设计、团队协作等功能，是<strong>免费设计工具</strong>中的佼佼者。</p>

<p>以上仅是<strong>免费在线工具</strong>的冰山一角。<strong>免费91 网页</strong>会持续收录和更新各类实用工具资源，帮助您构建高效的在线工作流。</p>`,
    image: 'https://readdy.ai/api/search-image?query=clean%20modern%20workspace%20with%20laptop%20displaying%20various%20productivity%20tools%2C%20organized%20desk%20setup%2C%20warm%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20cozy%20office%20atmosphere%2C%20soft%20shadows%2C%20professional%20photography&width=800&height=450&seq=article-free-tools-001&orientation=landscape',
    date: '2025-08-07',
    author: '91小编',
    tags: ['免费工具', '在线工具', '效率提升', '办公软件'],
    readTime: '10分钟',
    featured: true,
  },
  {
    id: 'art-006',
    title: '免费AI工具大盘点：零成本体验人工智能的强大',
    slug: 'free-ai-tools-collection',
    category: 'free-tools',
    excerpt: '汇总当前可免费使用的AI工具，从文本生成到图像创作，从代码辅助到数据分析，让人工智能为你的工作和创作赋能。',
    content: `<p>人工智能技术的飞速发展正在改变我们的工作和生活方式。令人欣喜的是，许多先进的AI工具都提供了免费版本，让普通用户也能体验到AI技术的魅力。本文将为您盘点当前最值得尝试的<strong>免费AI工具</strong>。</p>

<h2>一、文本与对话AI</h2>

<h3>1. ChatGPT 免费版</h3>
<p>OpenAI 推出的 ChatGPT 无疑是当下最热门的AI对话工具。免费版用户可以访问GPT-3.5模型，进行日常对话、文本创作、问题解答等。对于写作辅助、头脑风暴、学习辅导等场景，ChatGPT 是一个非常实用的<strong>免费AI助手</strong>。</p>

<h3>2. Claude 免费版</h3>
<p>Anthropic 开发的 Claude 是ChatGPT的有力竞争者，同样提供免费使用版本。Claude 在长文本处理和安全对齐方面表现突出，特别适合需要处理大量文字内容的用户。</p>

<h2>二、AI图像生成工具</h2>

<h3>1. Stable Diffusion 在线版</h3>
<p>Stable Diffusion 是开源的AI图像生成模型，多个在线平台提供了免费的生成服务。用户只需输入文字描述，AI就能创作出对应的图像。无论是概念设计、插画创作还是照片风格转换，都能轻松实现。</p>

<h3>2. Leonardo.AI</h3>
<p>Leonardo.AI 为免费用户提供了每日生成额度，平台专注于游戏和创意设计领域的AI图像生成。内置丰富的模型和风格预设，生成质量很高，特别适合<strong>免费AI绘画</strong>爱好者使用。</p>

<h2>三、其他实用AI工具</h2>

<h3>1. GitHub Copilot 免费版</h3>
<p>GitHub 为学生和开源项目维护者提供免费的 Copilot 使用权限。这款AI编程助手能够根据上下文自动补全代码，大幅提升编程效率，是<strong>免费编程助手</strong>中的佼佼者。</p>

<p>随着AI技术的持续进步，未来会有更多强大的免费AI工具涌现。<strong>免费91 网页</strong>将持续跟踪AI工具的最新动态，为读者提供最及时的资源导航。</p>`,
    image: 'https://readdy.ai/api/search-image?query=futuristic%20AI%20technology%20concept%20with%20holographic%20interface%2C%20warm%20ambient%20lighting%2C%20clean%20modern%20design%2C%20abstract%20neural%20network%20visualization%2C%20soft%20golden%20and%20coral%20tones%2C%20minimalist%20aesthetic&width=800&height=450&seq=article-free-tools-002&orientation=landscape',
    date: '2025-08-04',
    author: '91小编',
    tags: ['AI工具', '人工智能', '免费AI', '效率工具'],
    readTime: '8分钟',
    featured: false,
  },
  // ===== 免费学习 =====
  {
    id: 'art-007',
    title: '零基础学编程：2025年最佳免费编程学习资源汇总',
    slug: 'free-coding-learning-resources-2025',
    category: 'free-learning',
    excerpt: '为编程初学者整理的免费学习路线图，从入门到进阶，涵盖前端、后端、Python、AI等热门方向，助你零成本转行IT。',
    content: `<p>在数字化浪潮席卷各行各业的今天，编程已经成为一项越来越重要的技能。不管你是想转行IT行业，还是仅仅想掌握一门新技能，学习编程都是一个明智的选择。好消息是，你完全不需要花费高额学费，通过<strong>免费编程学习资源</strong>就能掌握编程技能。</p>

<h2>一、入门级编程课程</h2>

<h3>1. freeCodeCamp</h3>
<p>freeCodeCamp 是目前最受欢迎的免费编程学习平台之一。平台提供了完整的前端、后端、数据科学等学习路径，包含互动式编程练习和实际项目。完成全部课程后还能获得免费认证证书。中文版本也在不断完善中，是国内<strong>免费学编程</strong>的首选平台。</p>

<h3>2. CS50（哈佛大学计算机科学导论）</h3>
<p>哈佛大学的CS50课程被誉为全球最好的编程入门课程，完全免费开放。课程由浅入深，从 Scratch 到 C 语言再到 Python 和 Web 开发，内容覆盖面广且讲解精彩。David Malan 教授的讲课风格生动有趣，即使是零基础学习者也能轻松跟上。</p>

<h2>二、进阶学习平台</h2>

<h3>1. The Odin Project</h3>
<p>The Odin Project 是一个开源的 Web 开发学习平台，专注于培养全栈开发者。课程内容涵盖 HTML、CSS、JavaScript、React、Node.js 和 Ruby on Rails。每个模块都有大量的实践项目，帮助你建立扎实的编程基础和项目经验。</p>

<h3>2. MIT OpenCourseWare</h3>
<p>麻省理工学院开放课程项目提供了大量计算机科学相关的课程资源。从算法导论到人工智能，从操作系统到计算机网络，MIT的精品课程全部免费开放。这些<strong>免费计算机课程</strong>的质量与校内课程完全相同。</p>

<h2>三、编程练习平台</h2>

<h3>LeetCode 免费版</h3>
<p>LeetCode 是程序员面试准备的必备平台，免费版提供了上千道算法题目。通过刷题可以锻炼编程思维和算法能力，对于准备技术面试非常有帮助。平台上还有活跃的中文社区，可以查看他人的解题思路。</p>

<p>学习编程是一场马拉松而非短跑。<strong>免费91 网页</strong>将持续更新编程学习资源，陪伴每一位学习者在技术道路上不断成长。</p>`,
    image: 'https://readdy.ai/api/search-image?query=modern%20coding%20workspace%20with%20laptop%20displaying%20code%2C%20warm%20ambient%20lighting%2C%20clean%20desk%20setup%2C%20minimalist%20design%2C%20cozy%20atmosphere%2C%20soft%20golden%20light%2C%20professional%20photography%2C%20learning%20environment&width=800&height=450&seq=article-free-learning-001&orientation=landscape',
    date: '2025-08-08',
    author: '91小编',
    tags: ['编程学习', '免费课程', '零基础', 'IT技能'],
    readTime: '9分钟',
    featured: true,
  },
  {
    id: 'art-008',
    title: '免费在线语言学习平台：在家就能学好外语',
    slug: 'free-language-learning-platforms',
    category: 'free-learning',
    excerpt: '精选最佳免费语言学习工具和平台，涵盖英语、日语、韩语等热门语种，利用碎片时间高效提升语言能力。',
    content: `<p>掌握一门外语是打开新世界大门的钥匙。无论是为了职场发展、出国留学还是个人兴趣，学习外语都是一项值得投入的事业。幸运的是，现在有许多优秀的<strong>免费语言学习平台</strong>让外语学习变得轻松有趣。</p>

<h2>一、综合语言学习平台</h2>

<h3>1. Duolingo</h3>
<p>多邻国是全球最受欢迎的语言学习应用，完全免费使用。通过游戏化的学习方式，将语言学习变得像玩游戏一样有趣。支持英语、日语、韩语、法语等30多种语言的学习，每天只需15分钟就能有效提升语言水平。其<strong>免费外语学习</strong>模式已经帮助全球超过5亿用户。</p>

<h3>2. Busuu 免费版</h3>
<p>Busuu 提供12种语言的学习课程，免费版包含核心词汇和语法学习内容。平台的特色在于母语者社区互助，你可以将练习发送给母语者批改，也可以帮助其他学习者纠正中文。</p>

<h2>二、专项技能提升</h2>

<h3>1. HelloTalk</h3>
<p>HelloTalk 是一款语言交换应用，连接了全球数百万用户进行语言互学。你可以和母语者进行文字、语音和视频聊天，在实践中提升口语能力。</p>

<h3>2. BBC Learning English</h3>
<p>BBC 为英语学习者提供了丰富的免费学习资源。从6 Minute English到The English We Speak，内容涵盖新闻、文化、日常对话等。英式发音标准清晰，是<strong>免费英语学习</strong>的绝佳资源。</p>

<h2>三、实用学习技巧</h2>
<p>学习语言最重要的是坚持和沉浸。建议每天固定时间学习，同时利用碎片时间多听多看目标语言的素材。通过<strong>免费91 网页</strong>的语言学习导航，您可以找到最适合自己学习风格的工具和资源。</p>`,
    image: 'https://readdy.ai/api/search-image?query=language%20learning%20concept%20with%20books%20and%20digital%20devices%2C%20warm%20ambient%20lighting%2C%20cozy%20study%20corner%2C%20minimalist%20design%2C%20soft%20natural%20light%2C%20multilingual%20elements%2C%20clean%20composition&width=800&height=450&seq=article-free-learning-002&orientation=landscape',
    date: '2025-08-02',
    author: '91小编',
    tags: ['语言学习', '免费课程', '外语', '自学'],
    readTime: '7分钟',
    featured: false,
  },
  // ===== 免费阅读 =====
  {
    id: 'art-009',
    title: '免费电子书资源全攻略：百万好书零元读',
    slug: 'free-ebook-resources-guide',
    category: 'free-reading',
    excerpt: '整理最全免费电子书获取渠道，从古籍经典到现代畅销，从学术文献到网络小说，让你不花一分钱读遍好书。',
    content: `<p>阅读是获取知识和提升自我的最佳途径之一。随着数字阅读的普及，电子书已经成为许多人阅读的首选方式。然而，正版电子书的价格并不便宜。本文将为您整理最全面的<strong>免费电子书资源</strong>获取渠道，让阅读不再有门槛。</p>

<h2>一、公有领域电子书</h2>

<h3>1. 古登堡计划（Project Gutenberg）</h3>
<p>古登堡计划是全球最早的免费电子书项目，拥有超过60000本免费电子书。这些书籍都已进入公有领域，涵盖文学经典、哲学著作、历史文献等。支持多种格式下载，是<strong>免费英文电子书</strong>的宝库。</p>

<h3>2. 国学网</h3>
<p>国学网提供了大量中国传统经典的免费在线阅读，包括四书五经、诸子百家、诗词歌赋、明清小说等。对于喜爱中国传统文化的读者来说，这是不可多得的<strong>免费古籍资源</strong>。</p>

<h2>二、现代电子书平台</h2>

<h3>1. 微信读书</h3>
<p>微信读书虽然是付费平台，但通过阅读时长兑换书币、组队抽奖等方式，可以获得大量免费阅读的机会。平台的社交阅读功能也让阅读变得更有趣，可以与好友分享读书笔记和感悟。</p>

<h3>2. 豆瓣阅读</h3>
<p>豆瓣阅读有相当数量的免费电子书，特别是独立作者和新锐作家的作品。平台的评分和书评体系帮助读者快速筛选优质内容。定期举行的免费阅读活动也是获取好书的渠道。</p>

<h2>三、学术与专业资源</h2>

<h3>1. 知网免费资源</h3>
<p>中国知网虽然以收费著称，但其开放获取平台提供了大量免费学术论文。此外，通过学校或公共图书馆的知网入口，读者可以免费下载所需的学术文献。这些<strong>免费学术资源</strong>对于研究者和学生尤为重要。</p>

<p><strong>免费91 网页</strong>将持续更新阅读资源导航，帮助每一位爱书人找到心仪的读物。</p>`,
    image: 'https://readdy.ai/api/search-image?query=cozy%20reading%20nook%20with%20bookshelf%20and%20warm%20lighting%2C%20comfortable%20armchair%2C%20e-reader%20device%2C%20minimalist%20interior%2C%20soft%20natural%20light%2C%20peaceful%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20photography&width=800&height=450&seq=article-free-reading-001&orientation=landscape',
    date: '2025-08-05',
    author: '91小编',
    tags: ['免费电子书', '在线阅读', '数字阅读', '图书资源'],
    readTime: '8分钟',
    featured: true,
  },
  // ===== 免费游戏 =====
  {
    id: 'art-010',
    title: '免费在线游戏平台推荐：无需下载即点即玩的快乐',
    slug: 'free-online-game-platforms',
    category: 'free-games',
    excerpt: '盘点最受欢迎的免费在线游戏平台，涵盖休闲、竞技、策略、角色扮演等类型，打开浏览器就能畅玩。',
    content: `<p>游戏是许多人休闲娱乐的首选方式。然而，购买游戏主机和正版游戏需要不小的开支。幸运的是，互联网上有大量<strong>免费在线游戏</strong>可供选择，无需下载安装，打开浏览器就能玩。本文将为您介绍最值得体验的免费游戏平台。</p>

<h2>一、网页游戏平台</h2>

<h3>1. CrazyGames</h3>
<p>CrazyGames 是全球最大的网页游戏平台之一，拥有数千款免费游戏。涵盖射击、竞速、益智、多人对战等多种类型。所有游戏都经过筛选，质量有保障。平台还支持手柄操作和全屏模式，游戏体验不输客户端游戏。</p>

<h3>2. Poki</h3>
<p>Poki 是另一个高质量的网页游戏聚合平台，界面设计现代美观。平台上的游戏分类清晰，更新频繁，每天都有新游戏上线。特别适合在碎片时间玩上一两局，是<strong>免费小游戏</strong>的绝佳选择。</p>

<h2>二、客户端免费游戏</h2>

<h3>1. Epic Games Store</h3>
<p>Epic 游戏商城每周都会赠送1-2款免费游戏，许多都是3A大作或热门独立游戏。虽然需要下载客户端，但游戏本身的品质远超普通免费游戏。长期领取可以积累一个相当可观的游戏库。</p>

<h3>2. Steam 免费游戏区</h3>
<p>Steam 平台上有大量永久免费的高质量游戏，包括《DOTA2》《CS2》《Warframe》等热门作品。其中不少游戏的品质和内容量完全不输付费游戏，是<strong>免费电脑游戏</strong>的最佳来源。</p>

<h2>三、手机免费游戏推荐</h2>
<p>手机端也有大量优秀的免费游戏，如《王者荣耀》《和平精英》《原神》等。虽然这些游戏有内购系统，但不花钱也能获得完整的游戏体验。通过<strong>免费91 网页</strong>的游戏导航，您可以发现更多优质免费游戏资源。</p>`,
    image: 'https://readdy.ai/api/search-image?query=colorful%20gaming%20setup%20with%20RGB%20lighting%2C%20modern%20gaming%20monitor%20displaying%20video%20game%2C%20mechanical%20keyboard%2C%20warm%20ambient%20light%2C%20cozy%20gaming%20room%2C%20clean%20aesthetic%2C%20professional%20photography&width=800&height=450&seq=article-free-games-001&orientation=landscape',
    date: '2025-08-07',
    author: '91小编',
    tags: ['免费游戏', '在线游戏', '网页游戏', '游戏平台'],
    readTime: '7分钟',
    featured: true,
  },
];

export const articleMap: Record<string, Article> = {};
articles.forEach((article) => {
  articleMap[article.slug] = article;
});

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.featured);
}

export function getLatestArticles(limit: number = 6): Article[] {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);
}